export enum PlacePrivilege {
  MANAGE_MENU = 'MANAGE_MENU',
  MANAGE_ORDERS = 'MANAGE_ORDERS',
  MANAGE_ORDERS_HISTORY = 'MANAGE_ORDERS_HISTORY',
  MANAGE_REPORTS = 'MANAGE_REPORTS',
  MANAGE_RESERVATIONS = 'MANAGE_RESERVATIONS',
}
